import React from 'react';
import logo from './logo.svg';
import './App.less';
import {TheForm} from "./TheForm/TheForm";


function App() {
    return (
        <div className="App">
            <TheForm/>
        </div>
    );
}

export default App;
